<template>
  <div class="mobile-sidebar">
    <transition name="fadeLeft">
      <div v-show="showVisible" class="sidebar-div">
        <div class="sidebar-container">
          <div class="sidebar-title">
            <div style="display: flex; align-items: center">
              <div
                class="sidebar-btn black-color nav-left-item"
                style="height: 22px"
                @click="handleOpenD123()"
              >
                <img
                  src="@/assets/images/login/d123.png"
                  style="width: 22px; height: 22px"
                  alt=""
                />
              </div>
              <div class="sidebar-btn black-color nav-left-item" @click="closeSidbar">
                <i class="el-icon-time"></i>
              </div>
            </div>
            <div class="sidebar-user-chat">
              <div class="sidebar-btn black-color item" @click="handleNewChat">
                <i class="el-icon-circle-plus-outline"></i>
              </div>
              <div
                class="item"
                style="position: relative; cursor: pointer; height: 20px"
                @click="handleLogin"
              >
                <img
                  v-if="vipType"
                  class="vip-head-ranking"
                  src="@/assets/images/login/vip-head.png"
                />
                <el-avatar v-if="headImagePath" :size="20" :src="headImagePath" @error="true">
                  <img
                    style="width: 100%; height: 100%"
                    :src="require('@/assets/images/head_img.png')"
                  />
                </el-avatar>
                <el-avatar v-else :size="20" :src="require('@/assets/images/head_img.png')" />
              </div>
            </div>
          </div>
          <div class="sidebar-left">
            <mobile-history-session
              :session-history-list="sessionHistoryList"
              @getHistory="handleGetHistory"
            />
            <div class="sidebar-mask" @click="closeSidbar">&nbsp;</div>
          </div>
          <div v-if="isLogin" style="text-align: center" @click="handleLoginOut()">
            <el-button type="primary">{{ $t("common.logoutAccount") }}</el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import MobileHistorySession from "./MobileHistorySession";
export default {
  components: { MobileHistorySession },
  props: {
    showVisible: {
      type: Boolean,
      default: false,
    },
    sessionHistoryList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  computed: {
    isLogin() {
      return this.$store.state.user.userId != null;
    },
    headImagePath() {
      return this.$store.state.user.headImagePath;
    },
    vipType() {
      return this.$store.state.user.vipType;
    },
  },
  methods: {
    handleLogin() {
      window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxLogin";
    },
    handleOpenD123() {
      window.location.href = process.env.VUE_APP_D123_URL;
    },
    handleNewChat() {
      this.$emit("newChat");
    },
    closeSidbar() {
      this.$emit("callback");
    },
    async handleGetHistory(sessionId) {
      this.$emit("getHistory", sessionId);
    },
    // 退出登录
    async handleLoginOut() {
      await this.$store.dispatch("user/logout");
      this.$router.go(0);
    },
  },
};
</script>
<style lang="scss" scoped>
.vip-head-ranking {
  cursor: pointer;
  position: absolute;
  transform: rotate(20deg);
  top: -4px;
  right: -5px;
  width: 10px;
  height: 10px;
}

.mobile-sidebar {
  z-index: 9999;
  height: 100%;

  .sidebar-div {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 7777;
    left: 0;
    top: 0;
    .sidebar-container {
      opacity: 1;
      height: 100%;
      background-color: #fff;
      width: 268px;
      position: fixed;
      z-index: 99999;
      left: 0;
      top: 0;
      font-size: 14px;
      letter-spacing: 0.5px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
      transition: transform 0.2s;
      overflow-y: auto;
      .sidebar-user-chat {
        display: flex;
        align-items: center;
        .item {
          margin-right: 10px;
          &:last-child {
            margin-right: 0px;
          }
        }
      }
      .sidebar-left {
        padding: 10px 20px 10px;
        height: calc(100% - 100px);
      }
      a {
        color: var(--text-color);
      }

      .sidebar-message,
      .sidebar-userinfo {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        i {
          margin-right: 5px;
        }
      }

      .sidebar-message,
      .sidebar-navs {
        padding: 7px 0;
        border-bottom: 1px solid var(--border-color);
      }

      .sidebar-navs {
        display: block;
        text-align: left;

        .sidebar-nav-item {
          padding: 12px 0;

          i {
            font-size: 14px;
          }
        }

        .product-menu {
          margin-top: 10px;
          background-color: #f7f7f7;
          .menu-row {
            font-size: 12px;
            .menu-title {
              padding-left: 20px;
              font-size: 12px;
              text-align: left;
              color: #898989;
              height: 30px;
              line-height: 30px;
            }
            .menu-item {
              padding-left: 20px;
              text-align: left;
              height: 30px;
              line-height: 30px;
              font-weight: normal;
              a {
                color: #000;
              }
              a:hover {
                color: #000;
              }
            }
            .menu-item:hover {
              background-color: #ea660a;
              cursor: pointer;
              color: #fff;
              a {
                color: #fff;
              }
              a:hover {
                color: #fff;
              }
            }
          }
        }
      }

      .sidebar-userinfo {
        padding: 15px 0 8px 0;
      }

      .sidebar-menus {
        margin-left: 26px;

        .sidebar-menu-item {
          padding: 12px 0;
        }
      }

      .sidebar-login-btn {
        margin-top: 15px;
        width: 60%;
      }
    }

    .sidebar-mask {
      opacity: 0.9;
      height: 100%;
      width: 100%;
      position: fixed;
      z-index: -1;
      left: 0;
      top: 0;

      padding: 32px 24px;
      font-size: 14px;
      letter-spacing: 0.5px;
      transition: opacity 0.2s;
    }
  }
}
.overflow-hidden {
  line-height: 20px;
  height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.sidebar-title {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  .sidebar-btn {
    margin-top: 0px;
    i {
      color: #fff;
      font-size: 22px;
    }
  }
  .nav-left-item {
    margin-right: 10px;
    &:last-child {
      margin-right: 0px;
    }
  }
  .sidebar-btn.white-color {
    i {
      color: #fff;
    }
  }
  .sidebar-btn.black-color {
    i {
      color: #000;
    }
  }
}
</style>
